import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent } from "vue"

const _hoisted_1 = { class: "gfu-navbar-item" }
const _hoisted_2 = ["aria-label"]
const _hoisted_3 = { class: "_px-2 _pt-3 _pb-1 _flex _gap-2" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "_tc--light" }
const _hoisted_6 = {
  key: 1,
  class: "_mt-1"
}
const _hoisted_7 = { class: "gfu-link-underline__content" }
const _hoisted_8 = {
  key: 1,
  class: "_pa-2"
}
const _hoisted_9 = { class: "_flexcol _pa-2 _gap-2" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_user_avatar = _resolveComponent("user-avatar")
  const _component_base_title = _resolveComponent("base-title")
  const _component_drawer_header = _resolveComponent("drawer-header")
  const _component_revert_impersonation_button = _resolveComponent("revert-impersonation-button")
  const _component_mobile_navigation_separator = _resolveComponent("mobile-navigation-separator")
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_external_login_actions = _resolveComponent("external-login-actions")
  const _component_login_form = _resolveComponent("login-form")
  const _component_theme_selector = _resolveComponent("theme-selector")
  const _component_language_selector = _resolveComponent("language-selector")
  const _component_display_currency_selector_field = _resolveComponent("display-currency-selector-field")
  const _component_drawer = _resolveComponent("drawer")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      tabindex: "0",
      class: "gfu-navbar-btn",
      "aria-label": _ctx.Resources.Layout.UserBoxTriggerLabel,
      onClick: _cache[0] || (_cache[0] = (...args) => ($options.onAvatarClick && $options.onAvatarClick(...args)))
    }, [
      _createVNode(_component_user_avatar, { "avatar-size": 24 })
    ], 8 /* PROPS */, _hoisted_2),
    _createVNode(_component_drawer, {
      "is-open": _ctx.isDrawerOpen,
      onClose: $options.onClose
    }, {
      default: _withCtx(() => [
        _createVNode(_component_drawer_header, { onClose: $options.onClose }, {
          default: _withCtx(() => [
            _createVNode(_component_base_title, { level: "h3" }, {
              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                _createTextVNode("User Navigation", -1 /* CACHED */)
              ]))]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["onClose"]),
        ($options.isAuthenticated)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_user_avatar, { "avatar-size": 48 }),
                _createElementVNode("div", null, [
                  ($options.isImpersonated)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.Resources.Layout.UserBoxImpersonatingLabel), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true),
                  _createVNode(_component_base_title, { level: "h4" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.userContext.user.fullName), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.userContext.user.email), 1 /* TEXT */),
                  ($options.isImpersonated)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createVNode(_component_revert_impersonation_button, { "data-qa": "user-box-button:Revert" })
                      ]))
                    : _createCommentVNode("v-if", true)
                ])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.groupedLinks, (value, key) => {
                return (_openBlock(), _createElementBlock("div", { key: key }, [
                  _createVNode(_component_mobile_navigation_separator),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(value, (link) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: link.navigationItemId
                    }, [
                      (_openBlock(), _createBlock(_resolveDynamicComponent(link.tag), {
                        rel: link.rel,
                        class: "_flex _px-2 _py-1 _ai-c _gap-2 _jc-fs gfu-link-underline _cur-p",
                        href: link.to,
                        target: link.target,
                        onClick: link.action,
                        "data-qa": `user-box-button:${link.key}`
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_base_icon, {
                            "icon-namespace": link.icon.namespace,
                            name: link.icon.name,
                            "is-fixed-width": "",
                            size: "lg",
                            class: "_tc--accent"
                          }, null, 8 /* PROPS */, ["icon-namespace", "name"]),
                          _createElementVNode("span", _hoisted_7, _toDisplayString(link.label), 1 /* TEXT */),
                          (link.isTypeExternal)
                            ? (_openBlock(), _createBlock(_component_base_icon, {
                                key: 0,
                                name: "external-link",
                                "is-fixed-width": "",
                                class: "_tc--accent _ml-a"
                              }))
                            : _createCommentVNode("v-if", true)
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["rel", "href", "target", "onClick", "data-qa"]))
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ], 64 /* STABLE_FRAGMENT */))
          : (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createVNode(_component_external_login_actions, {
                "return-url": $options.returnUrl,
                class: "_mb-3",
                onSuccess: $options.onLoginSuccess
              }, null, 8 /* PROPS */, ["return-url", "onSuccess"]),
              _createVNode(_component_login_form, {
                "return-url": $options.returnUrl,
                onSuccess: $options.onLoginSuccess
              }, null, 8 /* PROPS */, ["return-url", "onSuccess"])
            ])),
        _createVNode(_component_mobile_navigation_separator),
        _createElementVNode("div", _hoisted_9, [
          ($options.isDarkModeEnabled)
            ? (_openBlock(), _createBlock(_component_theme_selector, { key: 0 }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.Resources.Layout.ThemeSelectorLabel), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }))
            : _createCommentVNode("v-if", true),
          _createVNode(_component_language_selector, {
            "display-name": _ctx.Resources.Layout.LanguageSelectorModalLabel
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.Resources.Layout.LanguageSelectorModalLabel), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["display-name"]),
          _createVNode(_component_display_currency_selector_field, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.Resources.ProjectHome.DisplayCurrenciesLabel), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          })
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["is-open", "onClose"])
  ]))
}